import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AutoComplete, Tag } from 'antd';

import PropTypes from 'prop-types';
import { fullDataDataPointsProps } from 'app/constants/PropType/propTypesFullData';

import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';

import { getTourPointAddress } from 'app/API/autocomplete';

import { setLatestSearchResult } from 'app/actions/FullTour/full_tour_view.action';

import { Point } from 'app/libs/map/drive/Point';
import withMobileDetecting from 'app/components/HOGs/detectMobileDesign';

import withTranslations from 'app/components/HOGs/withTranslations';
// import HistoryDropDownAdress from './HistoryDropDownAddress';
import { decodeSpecLetters } from 'app/components/Utility/utility';
import './AutoCompleteAddress.css';

const { Option } = AutoComplete;
const CODE_ESCAPE = 27;
let timer;

const AutoCompleteAddress = ({
  edit,
  point,
  prefix,
  suffix,
  getClass,
  setSelectedAutocomplete,
  itemClickHandler,
  isDragging,
  isMobileDesign,
  tr,
}) => {
  const dispatch = useDispatch();

  const [result, setResult] = useState([]);

  const [openDrop, setOpenDrop] = useState(false);

  const [onFocus, setOnFocus] = useState(false);

  const [renderDrop, setRenderDrop] = useState(false);

  const isExistEscListener = useRef(false);

  const [flagDropDownMouseOver, setFlagDropDownMouseOver] = useState(false);

  const link = useRef(null);

  useEffect(() => {
    timer = setTimeout(() => {
      setRenderDrop(true);
    }, 0);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    if (isDragging) {
      setOpenDrop(false);
    }
  }, [isDragging]);

  useEffect(() => {
    if (onFocus === true) {
      link.current.focus();
    } else {
      link.current.blur();
    }
  }, [onFocus]);

  const clearAutoProp = () => {
    document.removeEventListener('keydown', escFunction, false); //eslint-disable-line
    setResult([]);
    isExistEscListener.current = false;
  };

  const escFunction = (event) => {
    if (event.keyCode === CODE_ESCAPE) clearAutoProp();
  };

  const handleSearch = (value) => {
    let result = [];

    if (value) {
      if (!isExistEscListener.current) {
        document.addEventListener('keydown', escFunction, false);
        isExistEscListener.current = true;
      }
      if (value.length > 1) {
        result = [
          {
            value: `${tr.Searching}...`,
            data: 555,
            disabled: true,
          },
        ];
        getTourPointAddress(value, setResult);
      }
      setResult(result);
    } else {
      clearAutoProp();
    }
  };

  const handleSelect = (index, el) => {
    const { lat, lng } = el.props.rel;
    if (lat && lng) {
      publish(way.DRIVE_MAP_CLICK, { lat, lng, draggable: true, id: point.id });
      publish(way.DRIVE_LIST_SHOW_POINT_POS, { customeId: point.id });
      dispatch(
        setLatestSearchResult({
          value: el.props.children,
          data: el.props.rel,
        })
      );
    }
    clearAutoProp();
  };
  const children = result.map((el, i) => {
    if (el && el.data) {
      return (
        // eslint-disable-next-line react/no-array-index-key
        <Option key={el.value + i} rel={el.data} disabled={el.disabled}>
          <span>{el.value}</span>
          {el.tag ? <Tag>{el.tag.replace('_', ' ')}</Tag> : null}
        </Option>
      );
    }
    return null;
  });

  return (
    <span
      className="ant-input-affix-wrapper"
      onClick={() => itemClickHandler(point)}
      aria-hidden
    >
      <span
        className="ant-input-prefix"
        style={edit ? { justifyContent: 'flex-end' } : null}
      >
        {prefix()}
      </span>
      {!edit ? <div className="readOnlyInput" /> : null}
      {result.length === 1 && !result[0].data ? (
        <div
          className="no-address-found"
          onClick={() => {
            clearAutoProp();
          }}
          aria-hidden
        >
          {tr['No address found']}
        </div>
      ) : null}
      <AutoComplete
        onSearch={handleSearch}
        ref={(ref) => {
          setSelectedAutocomplete(ref, point);
          link.current = ref;
        }}
        placeholder={tr['Write address(create tour)']}
        defaultValue={
          !point.address && !point.isEmpty
            ? `${tr['Point address is loading']}...`
            : decodeSpecLetters(point.address)
        }
        className={getClass ? getClass() : ''}
        draggable={!!edit}
        // open={!!edit}
        open
        style={{ width: '100%' }}
        dropdownMatchSelectWidth={355}
        dropdownClassName="create_address_drop"
        key={point.id}
        disabled={point.type === Point.Type.DRAG}
        onSelect={handleSelect}
        autoFocus={false}
        onBlur={() => {
          clearAutoProp();
          if (!flagDropDownMouseOver) {
            setOpenDrop(false);
          }
        }}
        onChange={() => {
          setOpenDrop(false);
        }}
        onFocus={() => {
          if (isMobileDesign) {
            if (point.isEmpty) {
              setOpenDrop(true);
            } else {
              setOpenDrop(false);
            }
          } else if (point.isEmpty && renderDrop) {
            setOpenDrop(true);
          } else {
            setOpenDrop(false);
          }
        }}
      >
        {children}
      </AutoComplete>
      {/* <HistoryDropDownAdress
        openDrop={openDrop}
        setOpenDrop={setOpenDrop}
        setOnFocus={setOnFocus}
        pointId={point.id}
        setFlagDropDownMouseOver={setFlagDropDownMouseOver}
      /> */}
      {suffix ? suffix(point) : null}
    </span>
  );
};

AutoCompleteAddress.displayName = 'AutoCompleteAddress';
AutoCompleteAddress.propTypes = {
  edit: PropTypes.bool,
  point: PropTypes.shape(fullDataDataPointsProps),
  prefix: PropTypes.func,
  setSelectedAutocomplete: PropTypes.func,
};

export default withMobileDetecting(withTranslations(AutoCompleteAddress));
